import { getVehicleStatusLabel, getVehicleStatusColor } from '@/constants/fleet';
import BaseModel from './BaseModel';
import InspectionModel from './InspectionModel';

export default class FleetDashboardSummaryModel extends BaseModel {
  init(data) {
    this.vehicle_count = data.vehicle_count || 0;
    this.operating_vehicle_count = data.operating_vehicle_count || 0;
    this.inspection_pass_rate = Number.isFinite(data.inspection_pass_rate) ? data.inspection_pass_rate : null;
    this.inspection_pass_rate_window_days = data.inspection_pass_rate_window_days || 7;
    this.vehicle_expiring_documents = data.vehicle_expiring_documents || [];
    this.driver_expiring_documents = data.driver_expiring_documents || [];
    this.recent_inspections = (data.recent_inspections || []).map(item => new InspectionModel(item));
    this.open_work_order_count = data.open_work_order_count || 0;
    this.overdue_work_order_count = data.overdue_work_order_count || 0;
    this.recent_work_orders = data.recent_work_orders || [];
    this.upcoming_maintenance = data.upcoming_maintenance || [];
    this.vehicle_status_counts = (data.vehicle_status_counts || []).map(item => ([
      getVehicleStatusLabel(item.status),
      item.count,
      getVehicleStatusColor(item.status),
    ]));
  }
}
